import styled from 'styled-components';

export const Wrapper = styled.section`
  background: #333649;
  border-radius: 4px 4px 0px 0px;
  margin-top: 16px;
  margin-bottom: 16px;
  width: 128px;
  position: relative;
`;

export const ItemTopSection = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px 4px 0 0;
  height: 18px;
  width: 128px;
`;

export const ItemNumber = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  padding: 2px;
  margin-bottom: 0px;
  margin-left: 2px;
`;

export const ImageWrapper = styled.figure`
  width: 128px;
  height: 72px;
  margin: 0 !important;
  z-index: auto;
  display: block;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: auto;
  display: block;
`;

export const ImageContainer = styled.section`
  z-index: 0;
  display: block;
  background: #333649;
`;
